import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toast } from 'react-toastify';

import {
    Grid, Dialog, Button, IconButton, TextField, DialogContent, DialogTitle, useTheme, useMediaQuery
} from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CloseIcon from '@mui/icons-material/Close';

import './modalDatosIniciales.css';
import { iniUpdateBudget, budgetsUpdateInfoFactNotSave, iniUpdateBudgetModeTemplate } from '../../../redux/actions/pptos';
// import { AutocompleteCustomers } from './AutocompleteCustomers';
// const tipoFacturacion = ['directa', 'indirecta']

export const PptosInfoFacturacion = ({ open, setOpen }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // móvil: sm o menor

    const dispatch = useDispatch();
    const detailBudget = useSelector(state => state.ppto.detail)
    const { facturacion_nro_oc_cliente, facturacion_tipo, facturacion_id_cliente, facturacion_fecha, reading_mode, template_mode, facturacion_url_oc_cliente } = detailBudget

    const [form, setForm] = useState({
        facturacion_nro_oc_cliente: facturacion_nro_oc_cliente || null,
        facturacion_tipo: facturacion_tipo || 'directa', // directa e indirecta
        id_cliente: facturacion_id_cliente || null,
        facturacion_fecha: facturacion_fecha || null,
        facturacion_url_oc_cliente: facturacion_url_oc_cliente || null
    });

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value,
        });
    }

    const handleChangeDate = (newValue) => {
        setForm({
            ...form,
            facturacion_fecha: newValue
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const newDetail = {
            ...detailBudget,
            facturacion_nro_oc_cliente: form.facturacion_nro_oc_cliente,
            facturacion_tipo: form.facturacion_tipo,
            facturacion_id_cliente: form.id_cliente,
            facturacion_fecha: form.facturacion_fecha,
            facturacion_url_oc_cliente: form.facturacion_url_oc_cliente
        };

        if (newDetail.id > 0 && !template_mode) {
            dispatch(iniUpdateBudget(newDetail))
        } else {
            if (template_mode) {
                dispatch(iniUpdateBudgetModeTemplate(newDetail))
            } else {
                dispatch(budgetsUpdateInfoFactNotSave(newDetail))
                toast.success('Info facturación actualizados');
            }
        }
    }

    // const handleChangeCustomer = (customer) => {
    //     setForm({
    //         ...form,
    //         'id_cliente': customer.id_cliente
    //     })
    // }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={isMobile}
            PaperProps={{
                className: isMobile ? '' : 'min-w-[45%]'
            }}
        >

            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>

            <DialogTitle className='mt-3'>Info Facturación</DialogTitle>

            <DialogContent>
                <form onSubmit={handleSubmit}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                                <Grid item xs={12} className='mt-2'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Fecha facturación"
                                            inputFormat="DD/MM/YYYY"
                                            name="facturacion_fecha"
                                            value={form.facturacion_fecha}
                                            onChange={handleChangeDate}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                {/* <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Tipo facturación</InputLabel>
                                        <Select
                                            label="Tipo facturación"
                                            id="facturacion_tipo"
                                            name="facturacion_tipo"
                                            value={form.facturacion_tipo || ''}
                                            onChange={handleChange}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {tipoFacturacion.map(item => (
                                                <MenuItem
                                                    value={item}
                                                    key={item}
                                                    className='p-list-capitalize'>
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid> */}

                                {/* {form.facturacion_tipo === 'indirecta' &&
                                    < Grid item xs={12}>
                                        <AutocompleteCustomers
                                            form={form}
                                            handleChangeCustomer={handleChangeCustomer}
                                        />
                                    </Grid>
                                } */}

                                <Grid item xs={12}>
                                    <TextField
                                        className='p-box-referencia'
                                        label="Nro. Oc. cliente"
                                        name="facturacion_nro_oc_cliente"
                                        id="outlined-size-small"
                                        value={form.facturacion_nro_oc_cliente || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese número de oc del cliente'
                                        onChange={handleChange}
                                        disabled={reading_mode}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <div className='ms-1'>
                                        <div style={{ fontSize: '14px' }}>Adjunta enlace de la OC. Cliente</div>
                                        <div style={{ fontSize: '14px', color: 'gray' }}>Te facilita el seguimiento para futuras revisiones.</div>
                                        <div className='mt-2'>
                                            <input
                                                type="url"
                                                style={{
                                                    width: '100%',
                                                    border: '0px',
                                                    borderBottom: '1px solid lightgray',
                                                    padding: '5px',
                                                    fontSize: '13px',
                                                    outline: 'none'
                                                }}
                                                onChange={handleChange}
                                                placeholder='Ingrese enlace del archivo'
                                                name="facturacion_url_oc_cliente"
                                                value={form?.facturacion_url_oc_cliente || ''}
                                            />
                                        </div>
                                        <div className='ms-1 mt-2'>
                                            {(form?.facturacion_url_oc_cliente !== null && form?.facturacion_url_oc_cliente !== '') ?
                                                <a
                                                    className='p-links'
                                                    href={form?.facturacion_url_oc_cliente || ''}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Ver archivo
                                                </a>
                                                :
                                                ''
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>

                    <div style={{ marginTop: '27px', textAlign: 'right' }}>
                        <Button
                            id="id-button-save-ppto"
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='submit'
                        >
                            Guardar
                        </Button>
                    </div>

                </form>
            </DialogContent>
        </Dialog >
    )
}
